// extracted by mini-css-extract-plugin
export default {"container":"SnackBars_container__WvNc1","top":"SnackBars_top__7OSx5","left":"SnackBars_left__okKk0","right":"SnackBars_right__vhAbl","bottom":"SnackBars_bottom__yfn-M"};